<template>
  <div class="pd20x flex1">
    <AddCourse :visible="openClasses" @close="openClasses = false" :options="options" :data="currentItem" :edit="editClass" :allSubject="allSubject" @update="getData"></AddCourse>
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px">
        <div>物料（{{data.length}}条） </div>
        <div>
          <label>搜索：</label>
          <a-input-search v-model="filter.keywords" placeholder="搜索微信号" style="width: 200px" @search="()=>{pagination.page = 1;getData()}" class="mr10px"/>
          <a-button type="primary" @click="openClasses = true; currentItem = null; editClass = false">添加物料</a-button>
        </div>
      </div>
      <a-table
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          :rowKey="'id'"
          @change="changePage"
      >
        <template slot="id" slot-scope="text, record">
          {{record.id}}
        </template>
        <template slot="name" slot-scope="text, record">
          {{record.name}}
        </template>
        <template slot="erweima" slot-scope="text, record">
          <div class="imgWrap">
            <img :src="record.erweima" alt="">
          </div>
        </template>
        <template slot="wechat" slot-scope="text">
          {{text}}
        </template>
        <template slot="create_time" slot-scope="text">
          {{formatDate(text*1000)}}
        </template>
        <template slot="operation" slot-scope="text, record">
          <i class="z-icon editB" @click="openClasses = true; currentItem = record; editClass = true"></i>
          <i class="z-icon delete" @click="deleteItem(record.id)"></i>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import {get_service_list} from "@/libs/practice";

const columns = [{
  title: '序号',
  dataIndex: 'id',
  scopedSlots: { customRender: 'index' },
  align:'center'
},
  {
    title: '名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    align:'center'
  },
  {
    title: '二维码',
    dataIndex: 'erweima',
    scopedSlots: { customRender: 'erweima' },
    align:'center'
  },
  {
    title: '微信号',
    dataIndex: 'wechat',
    align:'center'
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    align:'center',
    scopedSlots: { customRender: 'create_time' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
import {formatDate} from '@/libs/moment'
import AddCourse from '@/components/practice/addService'
import * as http from '@/libs/practice'
import { routerlink } from '@/mixins/routerlink'
export default {
  name: 'classes',
  components: { AddCourse },
  mixins: [routerlink],
  data(){
    return{
      options: [],
      columns,
      filter:{
        keywords:''
      },
      pagination:{
        page: 1,
        size: '15',
        pageSize: 15
      },
      allSubject:[],
      data: [],
      areaval: '',
      openClasses: false,
      currentItem:'',
      editClass:false
    }
  },
  mounted(){
    this.$nextTick(()=>{
      Promise.all([]).then(res=>{
        this.getData()
      })
    })
  },
  methods:{
    formatDate,
    getData(){
      let request = {...this.filter,...this.pagination}
      http.get_service_list(request).then(res=>{
        const pagination = { ...this.pagination }
        pagination.total = res.total;
        this.data = res.data
        this.pagination = pagination;

      }).catch(error=>{
        console.log(error)
      })
    },
    handleChange(){

    },
    deleteItem(id){
      let _this = this
      this.$confirm({
        title: '是否确定删除该条信息?',
        centered: true,
        onOk() {
          http.del_service({id}).then(res=>{
            let {page, pagesize, total} = _this.pagination
            if(page>1 && Number(page-1)* 15 == total - 1){
              _this.pagination.page = Number(page-1)
            }
            _this.getData()
          }).catch(error=>{
            console.log(error)
          })
        },
      });
    },
    changePage({current}){
      this.pagination.page = current
      this.getData()
    },
    hideModal(){

    },
    onChange(){

    },
  }
}
</script>
<style lang="less" scoped>
.imgWrap{
  width: 120px;
  height: 70px;
  overflow: hidden;
  border-radius: 4px;
  margin: auto;
  img{
    width: 100%;
  }
}
</style>
